import ObRouting from "./obLayoutRouting";
import React, { useState } from "react";
import ToastMessage from "../components/generic/toastMessage";
import ee from "../components/utils/eventEmitter";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import OpRouting from "./opRouting";
import HoldingsRouting from "./holdingsRouting";
import PositionRouting from "./positionRouting";
import MarginFilesRouting from "./marginFilesRouting";
import FtRouting from "./ftRouting";
import bStrg, { parsedToken } from "../components/service/storageHelper";
import { jwtToken } from "../components/types/genericTypes";
import LoginRouting from "./login/loginRouting";
import FooterCont from "../components/footer/footer/footerCont";
import FooterRouting from "./footer/footerRouting";
import { Home } from "../components/home/home";
import { EdHeader } from "../components/header/edHeader";
import ClientRouting from "./clientRouting/clientRouting";
import PostLogin from "./postLogin";
import { ShowDocuments } from "../components/clientarea/serviceRequest/addressModification/showDocuments";

export const REdRouter = () => {
	const [showToast, setShowToast] = useState<{ message: React.ReactNode; color: "success" | "error" | "cancell" }>();
	//conatins the parsed jwtToken
	const pToken: jwtToken | null = parsedToken();

	const [currentpage, setCurrentpage] = useState<string | null>(bStrg("currentPage"));

	//temp code to be removed after integrating login
	ee.on("showToast", (e) => {
		setShowToast(e);

		setTimeout(() => {
			setShowToast(undefined);
		}, 5000000);
	});

	React.useEffect(() => {
		setCurrentpage(bStrg("currentPage"));
	}, [currentpage]);

	return (
		<section className={pToken ? "session_active" : "session_inactive"}>
			<section>
				{showToast && <ToastMessage {...showToast} />}
				<BrowserRouter basename={process.env.PUBLIC_URL}>
					{currentpage !== "login" && <EdHeader />}

					<>
						<ObRouting />
						<PositionRouting />
						<FtRouting />
						<OpRouting />
						<HoldingsRouting />
						<MarginFilesRouting />
						<LoginRouting />
						{/* <ClientRouting /> */}
						<FooterRouting />
						<Switch>
							<Route path="/" exact component={Home} />
							{/* <Route path="/serviceRequest/open" exact render ={props=><SRLayout {...props}  />}/>
							<Route path="/serviceRequest/disBooklet" exact render ={props=><SRLayout {...props} component={DISBooklet} />}/>
							<Route path="/serviceRequest/dpScheme" exact render ={props=><SRLayout {...props} component={DPScheme} />}/>  */}
							<PostLogin path= "/clientarea/service-request/" component={ClientRouting}/>
							<PostLogin path= "/showDocuments" exact component={ShowDocuments}/>
						</Switch>
					</>
					{currentpage !== "login" && <FooterCont />}
				</BrowserRouter>
			</section>
		</section>
	);
};
